// src/Features/Projects/routes/ProjectsRoutes.tsx
import { Routes, Route, Navigate } from "react-router-dom";

import { ROLE_COMBINATIONS } from "@/router/proxyRouter.definitions";

// Páginas do módulo Projects
import { ProjectsListPage, ProjectCreatePage, ProjectEditPage, ProjectDetailsPage } from "@/features/Projects";
import { RoleBasedRoute } from "..";

export function ProjectsRoutes() {
  return (
    <Routes>
      {/* Listagem de projetos */}
      <Route
        path=""
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_AND_PROJECT}>
            <ProjectsListPage />
          </RoleBasedRoute>
        }
      />

      {/* Criar novo projeto */}
      <Route
        path="create"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_AND_PROJECT}>
            <ProjectCreatePage />
          </RoleBasedRoute>
        }
      />

      {/* Detalhes do projeto */}
      <Route
        path=":id"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_AND_PROJECT}>
            <ProjectDetailsPage />
          </RoleBasedRoute>
        }
      />

      {/* Editar projeto */}
      <Route
        path=":id/edit"
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_AND_PROJECT}>
            <ProjectEditPage />
          </RoleBasedRoute>
        }
      />

      {/* Redirect padrão */}
      <Route path="*" element={<Navigate to="/projects" replace />} />
    </Routes>
  );
}
